module.exports = __webpack_public_path__ + "static/media/lidcore-sketch-3.13dc7178.jpg";